import { Component } from '@angular/core';

@Component({
	selector: 'app-refresh-route',
	template: '',
	standalone: true,
})
export class RefreshRouteComponent {}
